import { useTranslation } from "react-i18next";
import { Card, CardContent } from "@/components/ui/card";

const faqs = [
  { qKey: "contact.faq.q1", aKey: "contact.faq.a1" },
  { qKey: "contact.faq.q2", aKey: "contact.faq.a2" },
  { qKey: "contact.faq.q3", aKey: "contact.faq.a3" },
  { qKey: "contact.faq.q4", aKey: "contact.faq.a4" },
];

const FAQSection = () => {
  const { t } = useTranslation();

  return (
    <section className="py-20 bg-white" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-6">
        <div className="section-header">
          <span className="text-[#E07A5F] font-medium tracking-wider uppercase text-sm">
            {t("contact.faq.badge")}
          </span>
          <h2 className="mt-3">{t("contact.faq.title")}</h2>
        </div>
        <div className="space-y-6">
          {faqs.map((faq) => (
            <Card key={faq.qKey} className="bg-[#F4F1DE] border-0" data-testid={`faq-item-${faq.qKey}`}>
              <CardContent className="p-6">
                <h4 className="font-semibold text-[#3D405B] mb-2">{t(faq.qKey)}</h4>
                <p className="text-[#6B705C]">{t(faq.aKey)}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
